import { Injectable } from '@angular/core';
import { LoadingController, ToastController } from '@ionic/angular';
import { catchError, concatMap, exhaustMap, finalize, mergeMap, switchMap, take } from 'rxjs/operators';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpErrorResponse, HttpHeaders, HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { VariablesService } from '../variables.service';
import * as moment from 'moment';
import { AmPresenciaService } from '../am-presencia.service';
import { TokenALO } from 'src/app/Modelos/TokenALO';
import { globalConf } from 'src/app/Modelos/GlobalConf';
import { SwUpdate } from '@angular/service-worker';
import { ServiciosService } from '../servicios.service';

@Injectable({
  providedIn: 'root'
})
export class InterceptorService implements HttpInterceptor {

  public refrescandoToken = false;

  constructor(
    public variables: VariablesService,
    public amService: AmPresenciaService,
    public http: HttpClient,
    public toastController: ToastController,
    // ACTUALIZAR PWA
    public swUpdate: SwUpdate,
    public servicio: ServiciosService

  ) { }




  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {


    // // console.log("interceptor url ", req.url, " with params ", req.urlWithParams);
    // console.log("interceptor login correcto ", this.variables.loginCorrecto)

    // if(req.url.includes('alo/acceso')) {
    //   this.variables.loginCorrecto = true;
    //   // console.log("llamada desde alo ", req.url)
    //   return next.handle(req);
    // }

    // console.log("interceptor boolean req.url.includes('token') && !req.url.includes('tokenempresa')", (req.url.includes('token')) && !(req.url.includes('tokenempresa')))

    if ((req.url.includes('token')) && !(req.url.includes('tokenempresa'))) { // PETICION DE PEDIR TOKEN
      // console.log('interceptor por el token ', req.url)
      return next.handle(req);

    } else if (req.url.includes('/credenciales/')) return next.handle(req);

      else if (req.url.includes('/wsreto/services/wsreto')) {
      return next.handle(req).pipe(

        // CONTROLA EL POSIBLE ERROR QUE VENGA EN LA PETICION
        catchError((err: HttpErrorResponse) => {
          console.error("interceptor error", err.message);
          console.error("interceptor error", err);
          if (err.status == 500) {
            this.variables.credencialRetoValida = false
          }

          console.log("error de credencial ", this.variables.credencialRetoValida)




          return throwError(err.message);
        }),
        // CONTROLA QUE LA PETICION HA ACABADO
        finalize(async () => {
          console.log("interceptor Peticion " + req.url + " Finalizada");

          // await this.loadingCtrl.dismiss();

        })
      )
    }

    else if ((req.url.includes('api') || req.url.includes('alo/acceso')) && this.variables.loginCorrecto == true) {
      // console.log("interceptor Peticiones al servicio - req.url.includes('/api/' linea 57");

      // console.log('interceptor token valido ? ', this.tokenValido())

      if (this.tokenValido()) {
        // console.log('interceptor respuesta de tokenValido()', this.variables.tokenLogin.access_token)
        /* headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.variables.tokenLogin.access_token
        }), */
        // CLONA LA REQUEST Y LE AÑADE LAS CABECERAS QUE DETERMINES
        const authReq = req.clone({
          setHeaders: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + this.variables.tokenLogin.access_token,
          }


          // PARA AÑADIR A LA URL EL GUID DE EMPRESA
        });

        // DEVUELVE LA RESPUESTA A SU CAUCE
        return next.handle(authReq).pipe(

          // CONTROLA EL POSIBLE ERROR QUE VENGA EN LA PETICION
          catchError((err: HttpErrorResponse) => {
            // console.error("interceptor error", err.message);

            return throwError(err.message);
          }),
          // CONTROLA QUE LA PETICION HA ACABADO
          finalize(async () => {
            // console.log("interceptor Peticion " + req.url + " Finalizada");

            // await this.loadingCtrl.dismiss();

          })
        )

      } else {
        // console.log('interceptor PROCESO ACTUALIZACIÓN TOKEN');

        this.swUpdate.checkForUpdate().then(() => console.log('Comprobada version PWA al abrir aplicacion'));
        this.swUpdate.available.subscribe(async (event) => {
          this.servicio.presentLoading("Actualizando app ...");
          this.swUpdate.activateUpdate().then(() => {
            location.reload();
            this.servicio.dissmisLoading;
          }
          )
        })
        let body;
        if (this.variables.metodoAcceso == 'CredencialALO') {

          body = 'grant_type=password&username=' + this.variables.usuario + '&password=' + this.variables.pwd + "&scope=ALO"

        } else {

          body = 'grant_type=password&username=' + this.variables.credencialesEmpresa.GUID_Empresa + '&password=' + this.variables.clavePwdEmpresas + "&scope=Empresa"

        }
        return this.http.post(globalConf.url_api_presencia + globalConf.path_Token, body, {
          headers: {
            "Content-Type": "application/json"
          }
        }).pipe(
          concatMap((tokenInfo: any) => {
            // let fechaExpiracion = moment(tokenInfo['.expires']).subtract(19, "minutes").subtract('50',"seconds").format();

            this.variables.tokenLogin = {
              access_token: tokenInfo.access_token,
              token_type: tokenInfo.token_type,
              userName: tokenInfo.userName,
              expires: tokenInfo['.expires'],
              scope: tokenInfo['scope'],
              // expires: fechaExpiracion,
              expires_in: tokenInfo.expires_in,
              issued: tokenInfo['.issued']
            }
            // CLONA LA REQUEST Y LE AÑADE LAS CABECERAS QUE DETERMINES
            const authReq = req.clone({

              setHeaders: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + tokenInfo.access_token,
              }
            });

            // console.log("Interceptor Nuevo token", this.variables.tokenLogin)
            // DEVUELVE LA RESPUESTA A SU CAUCE
            return next.handle(authReq).pipe(

              // CONTROLA EL POSIBLE ERROR QUE VENGA EN LA PETICION
              catchError((err: HttpErrorResponse) => {
                // console.error(" interceptor ", err.message);

                return throwError(err.message);
              }),
              // CONTROLA QUE LA PETICION HA ACABADO
              finalize(async () => {
                // console.log("interceptor Peticion " + req.url + " Finalizada");

                // await this.loadingCtrl.dismiss();

              })
            )
          })
        )

      }

    } else {
      // console.log('interceptor por el else SI NO CONCUERDA CON NINGUNA URL SIGUE SU CURSO', req.url)
      // SI NO CONCUERDA CON NINGUNA URL SIGUE SU CURSO
      return next.handle(req);
    }

  }

  tokenValido() {

    // console.log('interceptor tokenValido() expires')

    //// console.log('interceptor tokenValido() expires', this.variables?.tokenLogin.expires)
    // console.log('interceptor tokenValido() ', this.variables.tokenLogin)

    if (this.variables.tokenLogin) {
      // console.log('interceptor tokenValido() expires_in', this.variables.tokenLogin.expires_in)
      let fechaExpiracion = moment(this.variables.tokenLogin.expires).format();
      if (moment().isBefore(moment(fechaExpiracion)) == false) {  // TOKEN INVALIDO
        return false;
      } else {
        return true;
      }


    } else {
      // console.log('interceptor tokenValido() teknlogin no existe')

      return false
    }


  }


  /* injectToken(req: HttpRequest<any>) {
    // COMPRUEBA LA FECHA DE EXPIRACION DEL TOKEN QUE HAY GUARDADO
    let fechaExpiracion = moment(this.variables.tokenLogin.expires).format();
    if (moment().isBefore(moment(fechaExpiracion)) == false) {  // TOKEN INVALIDO
 
      this.amService.getTokenUsuario(this.variables.usuario, this.variables.pwd).pipe(take(1))
        .subscribe((res: TokenALO) => {
          // console.log("Nuevo token");
 
          this.variables.tokenLogin = {
            access_token: res.access_token,
            token_type: res.token_type,
            userName: res.userName,
            expires: res['.expires'],
            expires_in: res.expires_in,
            issued: res['.issued']
          }
          return req.clone({
            setHeaders: {
              authorization: 'Bearer ' + res.access_token
            }
          });
 
        })
    } else {      // TOKEN VALIDO
      return req.clone({
        setHeaders: {
          authorization: 'Bearer ' + this.variables.tokenLogin.access_token
        }
      });
    }
 
  } */

}
